module.exports = __webpack_public_path__ + "img/taschenschrim.6f7d94ee.png";